import { getBookmarksForItems } from '../user/bookmark'
import { isSearchResultMatchesEqual } from '../../utils/item'
import { logSearchResult } from '../../utils/eventsApi'
import { trackSearchResultsDisplay } from '../../utils/tracking/trackSearchResultsDisplay'
import { getPageTypeFromURL } from '../../utils/location/getPageTypeFromUrl'

const onSearchPageDidUpdate = (
  locationParams,
  prevUserHasLoadAttempt,
  prevResults
) => {
  return (dispatch, getState) => {
    const state = getState()
    const { results, timeout } = state.searchPage
    const { currentSite } = state.common
    const { user } = state

    // Log to events api only when:
    // - user data will be loaded on search results page for the first time (initial search page render)
    // - successful search will be done after initial render
    // - timeout will happen (we need to log timeouts also)
    const newUserLoadAttempt = !prevUserHasLoadAttempt && user.hasLoadAttempt
    const isNewSearch = !isSearchResultMatchesEqual(
      results.matches,
      prevResults.matches
    )
    const isTimeout = user.hasLoadAttempt && timeout
    if (newUserLoadAttempt || isNewSearch || isTimeout) {
      const pageType = getPageTypeFromURL(window.location)
      logSearchResult({
        results,
        locationParams,
        currentSite,
        pathname: window.location.pathname,
        pageType,
        user,
        timeout
      })
      trackSearchResultsDisplay(currentSite)
    }
    if (newUserLoadAttempt || isNewSearch) {
      dispatch(getBookmarksForItems(results.matches.map(match => match.id)))
    }
  }
}

export default onSearchPageDidUpdate
